import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { ReservationService } from '@app/reservation/reservation.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-payment-template',
  templateUrl: './add-payment-template.component.html',
  styleUrls: ['./add-payment-template.component.scss']
})
export class AddPaymentTemplateComponent implements OnInit, OnDestroy {
  @Input() public editPaymentTemplateData: any; // only if editing
  @Input() public clientData: any;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  paymentTemplateFormGroup: FormGroup;
  error: string;
  addObservable: any;
  editObservable: any;
  deleteObservable: any;
  paymentCancelTimes: any = [];
  defaultInfoText: string;
  paymentCharged: FormArray;

  private ngUnsubscribe: Subject<any> = new Subject();
  daysList: number[];
  hoursList: number[];

  constructor(
    public activeModal: NgbActiveModal,
    private reservationService: ReservationService,
    private snackBar: MatSnackBar,
    public formBuilder: FormBuilder,
    private translateService: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    this.paymentCancelTimes = Array.from(Array.from(Array(Math.ceil((73 - 1) / 1)).keys()), x => 1 + x * 1);
    this.daysList = Array.from({ length: 90 }, (_, i) => i + 1);
    this.hoursList = Array.from({ length: 23 }, (_, i) => i + 1);
  }

  ngOnInit() {
    this.paymentTemplateFormGroup = this.formBuilder.group({
      name: ['', Validators.required],
      minGuests: [1, Validators.required],
      priceOption: ['guest', Validators.required],
      price: [0, Validators.required],
      cancelTime: [1, Validators.required],
      infoText: [''],
      paymentType: [0, Validators.required],
      paymentCharged: this.formBuilder.array([])
    });
    this.paymentInfoTemplate('guest');
    if (this.editPaymentTemplateData) {
      this.paymentTemplateFormGroup.addControl(
        'id',
        new FormControl(this.editPaymentTemplateData.id, Validators.required)
      );
      this.paymentTemplateFormGroup.get('name').setValue(this.editPaymentTemplateData.name);
      this.paymentTemplateFormGroup.get('minGuests').setValue(this.editPaymentTemplateData.minGuests);
      this.paymentTemplateFormGroup.get('priceOption').setValue(this.editPaymentTemplateData.priceOption);
      this.paymentTemplateFormGroup.get('price').setValue(this.editPaymentTemplateData.price);
      this.paymentTemplateFormGroup.get('cancelTime').setValue(this.editPaymentTemplateData.cancelTime);
      this.paymentTemplateFormGroup.get('infoText').setValue(this.editPaymentTemplateData.infoText);
      this.paymentTemplateFormGroup.get('paymentType').setValue(this.editPaymentTemplateData.paymentType);

      const allDays: any = [];

      if (this.editPaymentTemplateData.resPaymentCharged.length > 0) {
        this.editPaymentTemplateData.resPaymentCharged
          .sort((a: any, b: any) => a.id - b.id)
          .forEach((st: any) => {
            let groupData: any = {
              cancellationType: st.cancellationType,
              durationValue: st.cancellationType == 0 ? st.days : st.hours,
              chargedValue: st.chargedValue
            };
            allDays.push(this.formBuilder.group(groupData));
          });

        this.paymentTemplateFormGroup.setControl('paymentCharged', this.formBuilder.array(allDays));
      }
    }
    if (this.paymentTemplateFormGroup.value.paymentCharged.length == 0) {
      this.addNewDay();
    }
  }

  get formData() {
    return <FormArray>this.paymentTemplateFormGroup.get('paymentCharged');
  }

  addNewDay() {
    this.formData.push(this.createDay());
  }

  removeDay(index: number) {
    this.formData.removeAt(index);
  }

  getDurations(type: number): any[] {
    console.log(type);
    console.log(type == 0 ? [...this.daysList] : [...this.hoursList]);
    if (type == 0) {
      console.log('daysList', this.daysList);
      return [...this.daysList];
    } else {
      console.log('HoursList');
      return [...this.hoursList];
    }
  }

  createDay(): FormGroup {
    const group = this.formBuilder.group({
      cancellationType: [0, Validators.required],
      durationValue: [1, Validators.required],
      chargedValue: [1, Validators.required]
    });
    const index = this.formData.length;

    // group.get('cancellationType')!.valueChanges.subscribe(() => {
    //   group.get('durationValue').patchValue(1);
    //   this.cdr.detectChanges();
    // });

    return group;
  }

  trackByTypeAndValue(index: number, type: number) {
    return (_: number, duration: number) => `${index}-${type}-${duration}`;
  }

  getLabel(type: number, duration: number): string {
    if (type == 0) {
      return duration === 1
        ? this.translateService.instant('ResSettings.ResAddPaymentTemplate.Day')
        : this.translateService.instant('ResSettings.ResAddPaymentTemplate.Days');
    }
    return duration === 1
      ? this.translateService.instant('ResSettings.ResAddPaymentTemplate.Hour')
      : this.translateService.instant('ResSettings.ResAddPaymentTemplate.Hours');
  }
  ngOnDestroy(): any {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  minGuestsChanged(event: any) {
    this.paymentTemplateFormGroup.get('minGuests').setValue(event);
  }

  add() {
    if (!this.paymentTemplateFormGroup.valid) {
      this.snackBar.open('Bitte überprüfen Sie Ihre Angaben', '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
      return;
    }

    if (!this.validateDuplicatePolicies()) {
      return;
    }

    this.error = null;
    const payload = this.preparePayloadData();
    this.addObservable = this.reservationService
      .addPaymentTemplate(payload)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        (response: any) => {
          this.passEntry.emit(response);
        },
        err => {
          this.error = err.error.msg;
        }
      );
  }

  save() {
    if (!this.paymentTemplateFormGroup.valid) {
      this.snackBar.open('Bitte überprüfen Sie Ihre Angaben', '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
      return;
    }

    if (!this.validateDuplicatePolicies()) {
      return;
    }
    this.error = null;
    const payload = this.preparePayloadData();

    this.editObservable = this.reservationService
      .editPaymentTemplate(payload)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(
        (response: any) => {
          this.passEntry.emit(response);
        },
        err => {
          console.log('err', err);
          this.error = err.error.msg;
        }
      );
  }

  validateDuplicatePolicies(): boolean {
    const items = this.paymentTemplateFormGroup.value.paymentCharged;
    const seen = new Set();

    for (const item of items) {
      const key = `${item.cancellationType}-${item.durationValue}`;
      if (seen.has(key)) {
        this.snackBar.open('Doppelte Stornierungsrichtlinie gefunden', '', {
          duration: 3000,
          panelClass: ['snackbar-success']
        });
        return false;
      }
      seen.add(key);
    }

    return true;
  }

  preparePayloadData(): any {
    const formValue = this.paymentTemplateFormGroup.value;

    const transformedCharged = formValue.paymentCharged.map((item: any) => {
      const { cancellationType, durationValue, chargedValue } = item;

      if (cancellationType == 0) {
        return { days: durationValue, chargedValue, cancellationType };
      } else {
        return { hours: durationValue, chargedValue, cancellationType };
      }
    });

    return {
      ...formValue,
      paymentCharged: transformedCharged
    };
  }

  delete() {
    this.deleteObservable = this.reservationService
      .deletePaymentTemplate(this.paymentTemplateFormGroup.value.id)
      .takeUntil(this.ngUnsubscribe)
      .subscribe((response: any) => {
        const snackBarRef = this.snackBar.open('Anzahlungsvorlage erfolgreich gelöscht', '', {
          duration: 3000,
          panelClass: ['snackbar-success']
        });
        this.passEntry.emit('delete');
      });
  }

  addVariable(variable: string) {}

  paymentInfoTemplate(event: any) {
    let isPerPerson = event == 'guest' ? '(pro Person)' : '';
    if (this.paymentTemplateFormGroup.get('paymentType').value) {
      this.defaultInfoText = `Für diese Reservierung wird eine Kreditkartengarantie von [betrag] EUR ${
        this.paymentTemplateFormGroup.get('priceOption').value == 'guest' ? 'pro Person ' : ''
      }benötigt um bestätigt zu werden.\n`;
    } else if (this.clientData.pronominalForm && this.clientData.pronominalForm == 'sie') {
      this.defaultInfoText = `Diese Reservierung benötigt eine Anzahlung von [betrag] EUR ${isPerPerson} um bestätigt zu werden. Nach dem Abschluss der Reservierung haben Sie die Möglichkeit diese per Kreditkarte, Paypal oder SofortÜberweisung zu bezahlen.`;
    } else {
      this.defaultInfoText = `Diese Reservierung benötigt eine Anzahlung von [betrag] EUR ${isPerPerson} um bestätigt zu werden. Nach dem Abschluss der Reservierung hast du die Möglichkeit diese per Kreditkarte, Paypal oder SofortÜberweisung zu bezahlen.`;
    }
    this.paymentTemplateFormGroup.get('infoText').setValue(this.defaultInfoText);
  }

  // generateCancellationText(policies: any[]): string {
  //   let text = `Es gelten folgende Stornierungsrichtlinien:\n`;
  //   policies.forEach((policy, index) => {
  //     const time =
  //       policy.cancellationType == 0
  //         ? `${policy.durationValue} ${
  //             policy.durationValue > 1
  //               ? this.translateService.instant('ResSettings.ResAddPaymentTemplate.Days')
  //               : this.translateService.instant('ResSettings.ResAddPaymentTemplate.Day')
  //           }`
  //         : `${policy.durationValue} ${
  //             policy.durationValue > 1
  //               ? this.translateService.instant('ResSettings.ResAddPaymentTemplate.Hours')
  //               : this.translateService.instant('ResSettings.ResAddPaymentTemplate.Hour')
  //           }`;
  //     text += `Nr. ${index + 1} - ${time} ${this.translateService.instant(
  //       'ResSettings.ResAddPaymentTemplate.beforeReservation'
  //     )}: ${policy.chargedValue}%\n`;
  //   });

  //   return text;
  // }
}
